(() => {
	'use strict'

	// Fetch all the forms we want to apply custom Bootstrap validation styles to
	const forms = document.querySelectorAll('.needs-validation')

	// Loop over them and prevent submission
	Array.from(forms).forEach(form => {
		// Disable native HTML5 validation, com javasctript para se js não estiver ativo usar a validação nativa.
		form.noValidate = true;

		form.addEventListener('submit', event => {
			if (!form.checkValidity()) {
				event.preventDefault()
				event.stopPropagation()
			}

			form.classList.add('was-validated')
		}, false)
	})

	// Campo com erro escondido: lbDestacarCampo (lbalert.js) dispara
	// `lb-mostrar-campo` no campo e tenta de novo em 320 ms. Componentes que
	// recolhem (Bloco, Secao) abrem sozinhos com @lb-mostrar-campo; aqui
	// abrimos o resto do caminho: <details> fechado e painel de aba/passo
	// escrito como x-show="activeTab === 'x'" (troca para a aba do campo).
	// Só variáveis com cara de aba/passo — um x-show="modo === 'nota'" é
	// escolha da pessoa e não deve ser trocado para mostrar um campo.
	const VAR_ABA = /^(active|current|sub)?(tab|aba|step|passo|etapa|secao|painel)(atual|ativa|ativo)?$/i;
	const EXPR_ABA = /^\s*([A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*)*)\s*===?\s*(?:(['"])([^'"]*)\2|(\d+))\s*$/;

	document.addEventListener('lb-mostrar-campo', (e) => {
		let el = e.target instanceof Element ? e.target : null;
		while (el && el !== document.body) {
			if (el.tagName === 'DETAILS' && !el.open) el.open = true;
			const expr = el.getAttribute('x-show');
			const m = expr && window.Alpine && el.style.display === 'none' ? expr.match(EXPR_ABA) : null;
			if (m) {
				const partes = m[1].split('.');
				if (VAR_ABA.test(partes[partes.length - 1])) {
					try {
						let alvo = window.Alpine.$data(el);
						for (let i = 0; i < partes.length - 1 && alvo; i++) alvo = alvo[partes[i]];
						if (alvo && typeof alvo === 'object') alvo[partes[partes.length - 1]] = m[4] !== undefined ? Number(m[4]) : m[3];
					} catch (err) { /* aba que não dá para trocar: o aviso cai no toast */ }
				}
			}
			el = el.parentElement;
		}
	});

	// Erro do servidor que diz o campo (WP_Error com data.campo/data.field —
	// ex.: Telefone_Unico devolve campo "telefone" para número já em uso):
	// destaca o campo na tela. Devolve true se achou o campo; false = quem
	// chamou mostra o toast de sempre.
	const NOMES_DO_CAMPO = { telefone: ['telefone', 'lbdata_telefone', 'billing_phone', 'billing_cellphone'] };
	window.lbDestacarErroServidor = (resp, raiz) => {
		if (!resp || typeof resp !== 'object' || !window.lbDestacarCampo) return false;
		const d = (resp.data && typeof resp.data === 'object') ? resp.data : {};
		const campo = String(d.campo || d.field || resp.campo || resp.field || '');
		if (!campo) return false;
		const root = raiz instanceof Element ? raiz : document;
		const nomes = NOMES_DO_CAMPO[campo] || [campo];
		for (const n of nomes) {
			const q = (window.CSS && CSS.escape) ? CSS.escape(n) : n;
			const els = [...root.querySelectorAll(`[data-lb-campo="${q}"], [name="${q}"], [name="${q}[]"], [x-model="${q}"], [x-model$=".${q}"]`)];
			const el = els.find((e) => e.offsetParent) || els[0];
			if (el) {
				window.lbDestacarCampo(el, resp.message || '');
				return true;
			}
		}
		return false;
	};
})()